import * as React from 'react';
import { apiBaseUrl } from '../api';
import query from '../router/query';
import * as moment from 'moment';
import TaskAssignHiddenButton from './TaskAssignHiddenButton';
import TaskAssignNameSelect from './TaskAssignNameSelect'

export interface Task {
  id: number;
  description: string;
  completedBy: string | null;
  assignedTo: string[];
}

interface IDayTask extends Task {
  dayId: number;
}

interface IWeekTask extends Task {
  weekId: number;
}

interface IState {
  loading: boolean;
  error: string | undefined;
  dayTasks: IDayTask[];
  weekTasks: IWeekTask[];
  dayShift: number;
  weekShift: number;
  names: string[];
  activeNameAssigningIndex: number | undefined;
}

export default class Tasks extends React.Component<{}, IState> {

  constructor(props: {}) {
    super(props);
    const { day, week } = loadSavedTasks()
    this.state = {
      loading: false,
      error: undefined,
      dayTasks: day,
      weekTasks: week,
      dayShift: 0,
      weekShift: 0,
      names: ['arul', 'kassandra', 'matej'],
      activeNameAssigningIndex: undefined
    };
  }

  componentWillMount() {
    this.updateStateFromQueryStringAndFetchIfNeeded(this.state, true);
    document.body.addEventListener('mousedown', this.onMouseDown, true);
  }

  componentWillUpdate(nextProps: {}, nextState: IState) {
    this.updateStateFromQueryStringAndFetchIfNeeded(nextState);
  }

  onMouseDown = (event: MouseEvent) => {
    const anyEvent = event as any;
    if (this.state.activeNameAssigningIndex !== undefined) {
      const selectId = 'ns' + this.state.activeNameAssigningIndex
      if (!anyEvent.target || selectId !== anyEvent.target.id) {
        this.setState({
          activeNameAssigningIndex: undefined
        })
      }
    }
  }

  updateStateFromQueryStringAndFetchIfNeeded = (
    state: IState,
    isFromMount: boolean = false
  ) => {
    const { dayShift, weekShift } = state;
    const q = query();
    const qDayShift = Number(q.dayShift || 0);
    const qWeekShift = Number(q.weekShift || 0);
    if (dayShift !== qDayShift || weekShift !== qWeekShift) {
      this.setState(
        {
          dayShift: qDayShift,
          weekShift: qWeekShift
        },
        () => {
          this.fetchTasks();
        }
      );
    } else if (isFromMount) {
      this.fetchTasks();
    }
  };

  render() {
    const { dayShift, weekShift } = this.state;
    const today = new Date();
    const date = new Date();
    const days = dayShift + 7 * weekShift;
    date.setDate(date.getDate() + days);
    let dayTitle = "Today's tasks";
    const isToday = dayShift === 0 && weekShift === 0;
    if (!isToday) {
      const mDate = moment(date);
      dayTitle = `${mDate.format('ddd, MMM D, YYYY')}'s tasks`;
    }
    let weekTitle = "This week's tasks";
    const isThisWeek = isSameWeek(today, date);
    if (!isThisWeek) {
      const startOfWeekDate = getMonday(today);
      const endOfWeekDate = getMonday(today);
      endOfWeekDate.setDate(endOfWeekDate.getDate() + 6);
      const sStartOfWeekDate = moment(startOfWeekDate).format(
        'ddd, MMM D, YYYY'
      );
      const sEndOfWeekDate = moment(endOfWeekDate).format('ddd, MMM D, YYYY');
      weekTitle = `${sStartOfWeekDate} - ${sEndOfWeekDate} week's tasks`;
    }
    return (
      <div className="textContent">
        <div className="subNav">
          <a
            href={'/tasks'}
            style={{
              backgroundColor: isToday ? '#96d7da' : undefined
            }}
          >→ today ←</a>
          <span style={{ flex: 1 }} />
          <a href={`/tasks?dayShift=${dayShift - 1}&weekShift=${weekShift}`}>
            ← day
          </a>
          <span style={{ flex: 0.3, maxWidth: 20 }} />
          <a href={`/tasks?dayShift=${dayShift + 1}&weekShift=${weekShift}`}>
            → day
          </a>
          <span style={{ flex: 1 }} />
          <a href={`/tasks?dayShift=${dayShift}&weekShift=${weekShift - 1}`}>
            ← week
          </a>
          <span style={{ flex: 0.3, maxWidth: 20 }} />
          <a href={`/tasks?dayShift=${dayShift}&weekShift=${weekShift + 1}`}>
            → week
          </a>
        </div>
        <div>&nbsp;</div>
        <h2>{dayTitle}</h2>
        {this.dayTasks()}
        <h2>{weekTitle}</h2>
        {this.weekTasks()}
        <div>&nbsp;</div>
      </div>
    );
  }

  dayTasks = () => {
    const { dayTasks } = this.state;
    const tasks: React.ReactNode[] = dayTasks.map((task, i) => {
      return (
        <div
          key={i}
          style={{
            marginTop: 14,
            marginBottom: 14
          }}
        >
          <label>
            <input
              type="checkbox"
              checked={task.completedBy !== null}
              value={i}
              onChange={this.toggleDayTaskCompletion}
            />
            &nbsp;
            {task.description}
          </label>
          &nbsp;{this.nameAssigningComponent(task, i)}
        </div>
      );
    });
    return tasks;
  };

  weekTasks = () => {
    const { weekTasks } = this.state;
    const tasks: React.ReactNode[] = weekTasks.map((task, i) => {
      return (
        <div
          key={i}
          style={{
            marginTop: 14,
            marginBottom: 14
          }}
        >
          <label>
            <input
              type="checkbox"
              checked={task.completedBy !== null}
              value={i}
              onChange={this.toggleWeekTaskCompletion}
            />
            &nbsp;
            {task.description}
          </label>
          &nbsp;{this.nameAssigningComponent(task, i)}
        </div>
      );
    });
    return tasks;
  };

  nameAssigningComponent = (task: Task, index: number) => {
    if (task.completedBy) {
      return (
        <span>
          &nbsp;<strong>({task.completedBy})</strong>
        </span>
      );
    }
    const { activeNameAssigningIndex } = this.state;
    if (activeNameAssigningIndex !== index) {
      return (
        <TaskAssignHiddenButton
          task={task}
          index={index}
          onEnterTaskNameAssigning={this.onEnterTaskNameAssigning}
        />
      )
    }
    return this.nameElements(index, task);
  }

  nameElements = (taskIndex: number, task: Task) => {
    const { names } = this.state;
    const nameElements: React.ReactNode[] = [
      <option key="any" value="*">
        *
      </option>
    ];
    for (const name of names) {
      nameElements.push(
        <option key={name.toLowerCase()} value={name.toLowerCase()} selected={task.assignedTo[0] === name}>
          {name}
        </option>
      );
    }
    return (
      <TaskAssignNameSelect
        index={taskIndex}
        task={task}
        onNameChange={this.onNameChange}
      >
        {nameElements}
      </TaskAssignNameSelect>
    );
  };

  onEnterTaskNameAssigning = (index: number) => {
    this.setState({
      activeNameAssigningIndex: index
    })
  }

  onNameChange = (index: number, name: string, task: Task) => {
    this.onAsyncNameChange(index, name, task)
  }

  onAsyncNameChange = async (index: number, name: string, task: Task) => {
    if (name !== '*') {
      try {
        const result = await fetch(`${apiBaseUrl}tasks/${task.id}/assignUser?user=${name}`)
        if (result.status !== 200) {
          throw new Error('something went wrong')
        }
        task.assignedTo.push(name)
      } catch (error) {
        console.log('error assigning')
      }
      console.log('yahoo')
      this.setState({ activeNameAssigningIndex: undefined })
    } else {
      try {
        const result = await fetch(`${apiBaseUrl}tasks/${task.id}/removeUser?user=${task.assignedTo}`)
        if (result.status !== 200) {
          throw new Error('something went wrong')
        }
        const i = task.assignedTo.indexOf(name);
        if (i) {
          task.assignedTo.splice(i, 1);
        }
        this.setState({ activeNameAssigningIndex: undefined })
      } catch (error) {
        console.log('error assigning')
      }
    }
  }

  toggleDayTaskCompletion = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { dayTasks } = this.state;
    const element = event.currentTarget;
    const index = Number(element.value);
    const task = dayTasks[index];
    const complete = element.checked;
    let q = `${apiBaseUrl}tasks/`;
    const name = localStorage.getItem('name') || '';
    if (complete) {
      q += `complete?name=${encodeURI(name)}&`;
    } else {
      q += 'incomplete?';
    }
    q += `dayId=${task.dayId}&taskId=${task.id}`;

    try {
      const result = await fetch(q);
      if (result.status !== 200) {
        throw new Error('Bad request');
      }
      task.completedBy = complete ? name : null;
      element.checked = complete;
      this.forceUpdate();
    } catch (error) {
      console.log('failed to toggle (day)', error);
      element.checked = !complete;
    }
  };

  toggleWeekTaskCompletion = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { weekTasks } = this.state;
    const element = event.currentTarget;
    const index = Number(element.value);
    const task = weekTasks[index];
    const complete = element.checked;
    let q = `${apiBaseUrl}tasks/`;
    const name = localStorage.getItem('name') || '';
    if (complete) {
      q += `complete?name=${encodeURI(name)}&`;
    } else {
      q += 'incomplete?';
    }
    q += `weekId=${task.weekId}&taskId=${task.id}`;

    try {
      const result = await fetch(q);
      if (result.status !== 200) {
        throw new Error('Bad request');
      }
      task.completedBy = complete ? name : null;
      element.checked = complete;
      this.forceUpdate();
    } catch (error) {
      console.log('failed to toggle (week)', error);
      element.checked = !complete;
    }
  };

  fetchTasks = async () => {
    try {
      const { dayShift, weekShift } = this.state;
      const date = new Date();
      const days = dayShift + 7 * weekShift;
      date.setDate(date.getDate() + days);
      const url = `${apiBaseUrl}tasks?date=${date.toISOString()}`;
      const result = await fetch(url);
      if (result.status !== 200) {
        throw new Error('Bad request');
      }
      const json = await result.json();
      this.setState({ dayTasks: json.day, weekTasks: json.week });

      if (dayShift === 0 && weekShift === 0) {
        const day = {
          id: getDayId(date),
          tasks: json.day
        }
        const week = {
          id: getWeekId(date),
          tasks: json.week
        }
        localStorage.setItem('day', JSON.stringify(day))
        localStorage.setItem('week', JSON.stringify(week))
      }
    } catch (error) {
      console.log('failed to fetch');
    }
  };
}

function isSameWeek(d1: Date, d2: Date) {
  const d1Monday = getMonday(d1);
  const d2Monday = getMonday(d2);
  return (
    d1Monday.getDate() === d2Monday.getDate() &&
    d1Monday.getFullYear() === d2Monday.getFullYear()
  );
}

function getMonday(d: Date) {
  d = new Date(d);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}

function getDayId(d: Date) {
  const offset = new Date().getTimezoneOffset() * 60 * 1000;
  return Math.floor((d.getTime() + offset) / (1000 * 60 * 60 * 24))
}

function getWeekId(d: Date): number {
  const offset = new Date().getTimezoneOffset() * 60 * 1000;
  return Math.floor(((d.getTime() + offset) - (1000 * 60 * 60 * 24 * 4)) / (1000 * 60 * 60 * 24 * 7))
}

function loadSavedTasks() {
  const dayTasks = JSON.parse(localStorage.getItem('day') || '{"tasks":[]}')
  const weekTasks = JSON.parse(localStorage.getItem('week') || '{"tasks":[]}')
  const now = new Date()
  const dayId = getDayId(now);
  const weekId = getWeekId(now);
  return {
    day: dayTasks.id === dayId ? dayTasks.tasks : [],
    week: weekTasks.id === weekId ? weekTasks.tasks : []
  };
}



// WEBPACK FOOTER //
// ./src/tasks/Tasks.tsx